import axios, { AxiosResponse } from "axios";
import AxiosService from "./Axios";

const BASE_URL = "/alarm-event";

class AlarmEventApi {

    public async getStatisticsOverview(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/overview');
    }
    
    public async queryViews(request: QueryAlarmEventsRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/view/query', request);
    }

    public async ack(alarmEventId: string): Promise<AxiosResponse<any>> {
        return AxiosService.post('/alarm-event/ack', {
            eventId: alarmEventId
        });
    }
}


interface QueryAlarmEventsRequest {
    deviceId?: string,
    acked?: boolean,
    startTime?: number,
    endTime?: number,
    pageNo: number,
    pageSize: number,
}

export default AlarmEventApi;